export const TENANT_NODE_COLUMNS = {
  facilities: [
    { key: 'id', labelKey: 'tenantColFacilityId' },
    { key: 'name', labelKey: 'tenantColFacilityName' },
    { key: 'type', labelKey: 'tenantColFacilityType' },
    { key: 'address', labelKey: 'tenantColAddress' },
    { key: 'city', labelKey: 'tenantColCity' },
    { key: 'country', labelKey: 'tenantColCountry' },
    { key: 'location', labelKey: 'tenantColLocation' },
    { key: 'latitude', labelKey: 'tenantColLatitude' },
    { key: 'longitude', labelKey: 'tenantColLongitude' },
  ],
  products: [
    { key: 'product_name', labelKey: 'tenantColProductName' },
    { key: 'sku', labelKey: 'tenantColSku' },
    { key: 'category', labelKey: 'tenantColCategory' },
    { key: 'description', labelKey: 'tenantColDescription' },
  ],
  logistics: [
    { key: 'route_name', labelKey: 'tenantColRouteName' },
    { key: 'mode', labelKey: 'tenantColMode' },
    { key: 'origin', labelKey: 'tenantColOrigin' },
    { key: 'destination', labelKey: 'tenantColDestination' },
    { key: 'lead_time_days', labelKey: 'tenantColLeadTimeDays' },
    { key: 'cost', labelKey: 'tenantColCost' },
  ],
  geographies: [
    { key: 'country', labelKey: 'tenantColCountry' },
    { key: 'region', labelKey: 'tenantColRegion' },
    { key: 'city', labelKey: 'tenantColCity' },
    { key: 'risk_level', labelKey: 'tenantColRiskLevel' },
  ],
  commodities: [
    { key: 'commodity', labelKey: 'tenantColCommodity' },
    { key: 'category', labelKey: 'tenantColCategory' },
    { key: 'description', labelKey: 'tenantColDescription' },
    { key: 'unit', labelKey: 'tenantColUnit' },
  ],
  supplierFacilities: [
    { key: 'address_id', labelKey: 'tenantColAddressId' },
    { key: 'ticker', labelKey: 'tenantColSupplierTicker' },
    { key: 'facility_id', labelKey: 'tenantColFacilityId' },
    { key: 'facility_name', labelKey: 'tenantColFacilityName' },
    { key: 'street_address', labelKey: 'tenantColStreetAddress' },
    { key: 'city', labelKey: 'tenantColCity' },
    { key: 'state', labelKey: 'tenantColState' },
    { key: 'region', labelKey: 'tenantColRegion' },
    { key: 'postal_code', labelKey: 'tenantColPostalCode' },
    { key: 'country', labelKey: 'tenantColCountry' },
    { key: 'location', labelKey: 'tenantColLocation' },
    { key: 'latitude', labelKey: 'tenantColLatitude' },
    { key: 'longitude', labelKey: 'tenantColLongitude' },
    { key: 'address_type', labelKey: 'tenantColAddressType' },
    { key: 'facility_type', labelKey: 'tenantColFacilityType' },
    { key: 'is_primary', labelKey: 'tenantColIsPrimary' },
    { key: 'capacity_units', labelKey: 'tenantColCapacityUnits' },
    { key: 'capacity_value', labelKey: 'tenantColCapacityValue' },
    { key: 'capacity_share', labelKey: 'tenantColCapacityShare' },
    { key: 'operational_status', labelKey: 'tenantColOperationalStatus' },
    { key: 'headcount', labelKey: 'tenantColHeadcount' },
    { key: 'hs_codes', labelKey: 'tenantColHsCodes' },
    { key: 'since', labelKey: 'tenantColSince' },
    { key: 'certifications', labelKey: 'tenantColCertifications' },
    { key: 'uflpa_territory', labelKey: 'tenantColUflpaTerritory' },
    { key: 'export_control_zone', labelKey: 'tenantColExportControlZone' },
    { key: 'last_audit_date', labelKey: 'tenantColLastAuditDate' },
    { key: 'audit_outcome', labelKey: 'tenantColAuditOutcome' },
    { key: 'insurance_coverage', labelKey: 'tenantColInsuranceCoverage' },
    { key: 'natural_hazard_score', labelKey: 'tenantColNaturalHazardScore' },
    { key: 'single_site_risk', labelKey: 'tenantColSingleSiteRisk' },
    { key: 'lead_time_days', labelKey: 'tenantColLeadTimeDays' },
    { key: 'primary_port', labelKey: 'tenantColPrimaryPort' },
    { key: 'freight_mode', labelKey: 'tenantColFreightMode' },
    { key: 'avg_transit_days', labelKey: 'tenantColAvgTransitDays' },
    { key: 'annual_spend_share', labelKey: 'tenantColAnnualSpendShare' },
    { key: 'last_verified_at', labelKey: 'tenantColLastVerifiedAt' },
    { key: 'verified_by', labelKey: 'tenantColVerifiedBy' },
    { key: 'data_source', labelKey: 'tenantColDataSource' },
    { key: 'confidence_rating', labelKey: 'tenantColConfidenceRating' },
  ],
  graphRelationships: [
    { key: 'source', labelKey: 'tenantColSource' },
    { key: 'target', labelKey: 'tenantColTarget' },
    { key: 'relationship_type', labelKey: 'tenantColRelationshipType' },
    { key: 'weight', labelKey: 'tenantColWeight' },
    { key: 'notes', labelKey: 'tenantColNotes' },
  ],
};

export const getEmptyRowForNodeKey = (nodeKey) => {
  const cols = TENANT_NODE_COLUMNS[nodeKey] || [];
  return cols.reduce((acc, col) => {
    acc[col.key] = '';
    return acc;
  }, {});
};
